import { slicedToArray as _slicedToArray, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { SelectFilter } from './SelectFilter.js';
import { i18n } from '../../i18n/translate.js';
import { ToggleCheckbox } from '../toggle-checkbox/component.js';

var ToggleFilter = function ToggleFilter(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      checked = _useState2[0],
      setChecked = _useState2[1];

  useEffect(function () {
    setChecked(props.value);
  }, [props.value]);

  var CustomOption = function CustomOption(_ref) {
    var innerRef = _ref.innerRef,
        innerProps = _ref.innerProps,
        props = _ref.props;
    return /*#__PURE__*/React.createElement(ToggleCheckbox, _extends({
      ref: innerRef
    }, innerProps, props, {
      className: "round sm",
      label: getOptions()[0].label,
      leftToggle: true,
      checked: checked,
      onChange: onChange
    }));
  };

  CustomOption.propTypes = {
    innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
      current: PropTypes.any
    })]),
    innerProps: PropTypes.object,
    props: PropTypes.object
  };

  var getOptionLabel = function getOptionLabel() {
    var label = '';

    if (checked) {
      label = props.checkedLabel || "".concat(i18n.t('Filtering by'), " ").concat(props.label);
    } else {
      label = props.uncheckedLabel || "".concat(i18n.t('Not Filtering by'), " ").concat(props.label);
    }

    return label;
  };

  var getOptions = function getOptions() {
    return [{
      id: checked,
      label: getOptionLabel()
    }];
  };

  var onChange = function onChange() {
    setChecked(function (prevChecked) {
      return !prevChecked;
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "toggle-filter"
  }, /*#__PURE__*/React.createElement(SelectFilter, _extends({}, props, {
    customComponent: {
      Option: CustomOption
    },
    isClearable: false,
    name: "toggle_filter",
    options: getOptions()
  })));
};

ToggleFilter.displayName = "ToggleFilter";
ToggleFilter.propTypes = {
  checkedLabel: PropTypes.string,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  uncheckedLabel: PropTypes.string,
  value: PropTypes.bool
};
export { ToggleFilter };